<template>
  <div class="package_add_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <form @submit.prevent="addPackage" style="padding:15px;">
            <div class="form-group">
              <label for="parent_model">Package Parent Model *</label>
              <input
                :class="{
                  'is-invalid': $v.parent_model.$invalid && submit,
                  'is-valid': !$v.parent_model.$invalid && submit
                }"
                type="text"
                v-model="parent_model"
                class="form-control"
                id="parent_model"
                name="parent_model"
                aria-describedby="model_help"
                placeholder="Parent Model i.e:SM08-180"
              />
              <div class="invalid-feedback">
                Please provide a parent model Number
              </div>
            </div>

            <div class="form-group">
              <label for="parent_model" class="package_ingredient_label mb-3"
                >Ingredients *</label
              >
              <button
                class="btn btn-sm btn-success add_btn ml-3"
                @click="addIngredient"
                type="button"
              >
                Add Ingredient
              </button>

              <div v-for="(v, index) in $v.sons.$each.$iter" :key="index">
                <div class="form-group">
                  <div class="row">
                    <div class="col-5">
                      <label class="form_label"
                        >Model {{ parseInt(index) + 1 }}</label
                      >
                      <input
                        class="form-control"
                        v-model.trim="v.model.$model"
                        :class="{ 'is-invalid': v.model.$invalid && submit }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!v.model.required && submit"
                      >
                        Name is required.
                      </div>
                    </div>
                    <div class="col-5">
                      <label class="form_label"
                        >Qty {{ parseInt(index) + 1 }}</label
                      >
                      <input
                        class="form-control"
                        v-model.trim="v.qty.$model"
                        :class="{ 'is-invalid': v.qty.$invalid && submit }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!v.qty.required && submit"
                      >
                        Quantity is required.
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!v.qty.numeric && submit"
                      >
                        Quantity has to be a number.
                      </div>
                    </div>
                    <div class="col-1">
                      <button
                        class="btn btn-sm btn-danger delete_btn"
                        v-if="index > 0"
                        @click="deleteIngredient(index)"
                        type="button"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button class="btn btn-success" type="submit">Submit</button>
          </form>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
export default {
  name: "shopify-package-add",
  components: {},
  data() {
    return {
      submit: false,
      parent_model: "",
      sons: [
        {
          model: "",
          qty: ""
        }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Packages", to: { name: "packages" } },
        { text: "Add New Package", active: true }
      ]
    };
  },
  validations: {
    parent_model: {
      required
    },
    sons: {
      required,
      $each: {
        model: {
          required
        },
        qty: {
          required,
          numeric
        }
      }
    }
  },
  methods: {
    deleteIngredient(index) {
      this.sons.splice(index, 1);
    },
    addIngredient() {
      this.sons.push({
        model: "",
        qty: ""
      });
    },
    addPackage() {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let packageData = {
          parentModel: this.parent_model,
          sons: this.sons
        };

        this.$http
          .post(this.APIURL + this.BRAND + "/packages", packageData)
          .then(
            () => {
              this.$swal({
                title: "Success!",
                showConfirmButton: false,
                timer: 1000,
                html:
                  "Package added successfully, taking you back to package list.",
                type: "success",
                onClose: () => {
                  loader.hide();
                  this.$router.push({ name: "packages" });
                }
              });
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }
};
</script>
